import { render } from "./Image.vue?vue&type=template&id=e5c489be&scoped=true"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"

import "./Image.vue?vue&type=style&index=0&id=e5c489be&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e5c489be"

export default script